/**
 * Business Information Card for Accountant Report View
 * Displays business details, location, zone, and event information
 */

import React from 'react';

interface BusinessInfoProps {
  businessType: string;
  businessAddress: string;
  zone: string;
  coverageYear?: number;
  eventType?: string;
  eventStartDate?: string;
  eventEndDate?: string;
}

export default function BusinessInfoCard({
  businessType,
  businessAddress,
  zone,
  coverageYear,
  eventType,
  eventStartDate,
  eventEndDate
}: BusinessInfoProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
      <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
        <span className="text-2xl mr-2">🏢</span>
        Business Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-600">Business Type</p>
          <p className="text-base font-semibold text-gray-900">{businessType}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Location</p>
          <p className="text-base font-semibold text-gray-900">{businessAddress}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Zone</p>
          <p className="text-base font-semibold text-gray-900">{zone}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Coverage Year</p>
          <p className="text-base font-semibold text-gray-900">{coverageYear}</p>
        </div>
        {eventType && (
          <>
            <div>
              <p className="text-sm text-gray-600">Event Type</p>
              <p className="text-base font-semibold text-gray-900">{eventType}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Event Period</p>
              <p className="text-base font-semibold text-gray-900">
                {eventStartDate && new Date(eventStartDate).toLocaleDateString()} - {eventEndDate && new Date(eventEndDate).toLocaleDateString()}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
